<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col cols="12" offset-xs="0">
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile}"
          v-html="$t('agency.title')"
        ></h1>
      </v-col>
      <v-col cols="12" offset-xs v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="6" md="4" offset-xs="0">
        <v-select
          v-model="selectedDeliveryMonth"
          :items="deliveryMonths"
          item-title="label"
          item-value="value"
          :label="$t('commons.form.select.measureperiod.yearmonth-cpm')"
          class="select-digestives"
          @update:modelValue="previewAgencyList()"
          return-object
          variant="underlined"
        ></v-select>
      </v-col>
      <v-col cols="6" md="6" offset-xs="0">
        <v-text-field v-model="inputAgencyName" label="代理店名" @change="previewAgencyList()" variant="underlined"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="agencyListHeaders"
          :items="agencyList"
          :hide-default-header="isMobile"
          hide-default-footer
          :sort-by="sortBy"
          :sortDesc="false"
          :loading="isSearching"
          :items-per-page="-1"
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3 agency-list"
          :class="{mobile: isMobile}"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-left break-word-cell caption">
                <span class="link" @click=navigateToAdvertiserList(props.item.agencyId)>{{ props.item.agencyName }}</span>
              </td>
              <td class="text-center">
                <a target="_blank" @click="logicadLink(`${props.item.agencyId}`)">
                  <span>
                    <v-icon style="height: 16px">mdi-open-in-new</v-icon>
                  </span>
                </a>
              </td>
            </tr>
            <tr v-else>
              <td @click="navigateToAdvertiserList(props.item.agencyId)">
                <v-row align="center">
                  <v-col cols="11">
                    <ul class="flex-content body-2">
                      <li
                        class="flex-item word-break "
                        :data-label="$t('agency.headers.agencyName')"
                      >{{ props.item.agencyName }}</li>
                    </ul>
                  </v-col>
                  <v-col cols="1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AgencyList',
  data: function () {
    return {
      sortBy: [{ key: 'agencyName', order: 'asc' }],
      isSearching: false,
      selectedDeliveryMonth: {},
      deliveryMonths: [],
      inputAgencyName: '',
      agencyListHeaders: [
        {
          title: this.$t('agency.headers.agencyName'),
          align: 'left',
          key: 'agencyName',
          width: '600'
        },
        {
          title: this.$t('agency.headers.logicadLink'),
          align: 'center',
          key: 'logicadLink',
          width: '140',
          sortable: false
        }
      ],
      agencyList: [],
      isMobile: false,
      errorMessage: undefined,
      webUrl: undefined
    }
  },
  methods: {
    ...mapActions('deliveryMonth', ['getMonthAllList', 'setSelectedDeliveryMonth']),
    ...mapActions('agency', ['getAgencyList']),
    initialize: function () {
      // カレンダーの初期化とリストの初期表示
      this.getMonthAllList().then((result) => {
        this.deliveryMonths = result
        const params = 'deliveryMonth/selectedDeliveryMonth'
        // 当月を指定する（全てが存在するから配列２）
        var defaultDeliveryMonth = result[2]
        if (this.$route.query.yearMonth !== undefined) {
          for (var i in result) {
            if (this.$route.query.yearMonth === result[i].value) {
              defaultDeliveryMonth = result[i]
            }
          }
        } else if (this.$store.getters[params] !== undefined) {
          defaultDeliveryMonth = this.$store.getters[params]
        }
        this.selectedDeliveryMonth = defaultDeliveryMonth
        this.previewAgencyList()
      })
      this.webUrl = process.env.WEBURL
    },
    previewAgencyList: function () {
      this.isSearching = true
      const jwtToken = this.$store.getters['auth/jwtToken']
      const deliveryMonth = this.selectedDeliveryMonth.value
      this.setSelectedDeliveryMonth(this.selectedDeliveryMonth)
      const agencyName = this.inputAgencyName

      // URLにパラメータを付与
      this.$router.replace({
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });

      this.getAgencyList({
        privateCode: process.env.ProjectCode,
        deliveryMonth: deliveryMonth,
        agencyName: agencyName,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.isSearching = false
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.agencyList = []
            return
          }
          this.agencyList = result.agencyList
        })
        .catch((err) => {
          this.isSearching = false
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.replace('/login')
              .catch(routerErr => {
              });
          }
        })
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    navigateToAdvertiserList: function (agencyId) {
      this.$router.push({ path: `../advertiserList/${agencyId}` })
    },
    logicadLink: function (agencyId) {
      const logicadURL = process.env.LOGICADURL + agencyId + '/0/report/campaign/search.html'
      window.open(logicadURL, '_blank')
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    this.initialize()
  }
}
</script>
<style scoped>
.agency-list .break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
</style>
